window.lang2 = 
{
  "general": {
    "meta": {
      "tags": "Etiquetado \"{{ tags }}\"",
      "page": "Página {{ page }}"
    },
    "404": {
      "title": "404 Página no encontrada",
      "subtext_html": "La página que ha solicitado no existe. Haga clic <a href=\"\/collections\/all\">aquí<\/a> para continuar la compra."
    },
    "breadcrumbs": {
      "home": "Inicio",
      "home_link_title": "Volver a la portada"
    },
    "newsletter_form": {
      "newsletter_email": "email@ejemplo.com",
      "submit": "Suscribir",
      "title": "Communidad",
      "text": "Entra tu correo",
      "noitice": "No mostrar popup",
      "go": "Ir",
      "ok": "ok",
      "subscribe": "Subscribir"
    },
    "search": {
      "no_results_html": "Su búsqueda de \"{{ terms }}\" no tuvo resultados.",
      "results_for_html": "Su búsqueda de \"{{ terms }}\" muestra lo siguiente:",
      "title": "Buscar productos en nuestro sitio",
      "placeholder": "buscar en nuestra tienda",
      "submit": "Buscar"
    },
    "date": {
      "year_text": "años",
      "month_text": "meses",
      "week_text": "semanas",
      "day_text": "dias",
      "year_singular_text": "año",
      "month_singular_text": "mes",
      "week_singular_text": "semana",
      "day_singular_text": "día",
      "hour_text": "horas",
      "min_text": "minutos",
      "sec_text": "segundos",
      "hour_singular_text": "Hora",
      "min_singular_text": "Min",
      "sec_singular_text": "Seg"
    },
    "modal": {
      "continue_shopping": "Continuar",
      "go_to_cart": "Ir al carrito",
      "qty": "Cantidad:",
      "total": "Total:",
      "go_to_wishlist": "Mi Lista",
      "wishlist_text": "Lista",
      "add_to_wishlist_message": "Fue añadido a tu lista:",
      "add_to_cart_message": "Haz añadido este producto a tu carrito:",
      "cart_text": "Excluir estampa"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Publicado por {{ author }} en {{ date }}",
      "older_post": "Publicación más antigua",
      "newer_post": "Publicación más reciente",
      "tags": "Etiquetas",
      "comment_meta_html": "{{ author }} en {{ date }}",
      "read_more": "Leer más",
      "by_admin": "Por {{ author }}"
    },
    "comments": {
      "title": "Dejar un comentario",
      "name": "Nombre",
      "email": "Correo electrónico",
      "message": "Mensaje",
      "post": "Publicar comentario",
      "moderated": "Por favor tenga en cuenta que los comentarios deben ser aprobados antes de ser publicados",
      "success_moderated": "Su comentario se ha compartido con éxito. Lo publicaremos en un momento, en tanto nuestro blog sea moderado.",
      "success": "¡Su comentario se ha compartido con éxito! ¡Gracias!",
      "comments_with_count": {
        "one": "{{ count }} comentario",
        "other": "{{ count }} comentarios"
      }
    },
    "sidebar": {
      "recent_articles": "Artículos recientes",
      "categories": "Categorías",
      "video": "Ultimo Video",
      "tags": "Etiqueta"
    }
  },
  "cart": {
    "general": {
      "title": "Carrito de compra",
      "remove": "Quitar",
      "note": "Instrucciones especiales para el vendedor",
      "subtotal": "Subtotal",
      "shipping_at_checkout": "Gastos de envío y descuentos calculado al momento de pagar",
      "update": "Actualizar carrito",
      "checkout": "Finalizar pedido",
      "empty": "Su carrito actualmente está vacío.",
      "continue_browsing_html": "Continúe explorando <a href=\"\/collections\/all\">aquí<\/a>.",
      "close_cart": "Cerrar carrito",
      "edit": "Editar",
      "carttotals": "Total en el carrito",
      "grandtotal": "Total Final",
      "continue": "Continua tu compra",
      "shipping_calculator_error_message": "ErrorL Por favor entra la información de envio correctamente",
      "shipping_calculator_success_many_rates": {
        "there_are": "Hay",
        "shipping_rates_available_for": "Precios de envio disponible para",
        "starting_at": ", empezando en"
      },
      "shipping_calculator_success_one_rate": "No hay precios de envío para",
      "shipping_calculator_success_no_rate": "No hay tarifas de envío para el destino de esta orden.",
      "shipping_calculator_success_at": "en"
    },
    "label": {
      "product": "Producto",
      "price": "Precio",
      "quantity": "Cantidad",
      "total": "Total",
      "update_cart": "Actualizar el carrito",
      "remove": "Remover"
    },
    "header": {
      "view_cart": "Ver carrito",
      "checkout": "Revisar Compra",
      "total": "Total:",
      "total_numb": "artículo(s):",
      "no_item": "No tienes artículos en tu carrito de compras.",
      "remove_this_item": "Remover artículo"
    },
    "shipping": {
      "title": "Envío e impuesto estimado",
      "title_form": "Ingrese su destino para obtener un precio estimado de envío.",
      "country": "País",
      "state": "Estado",
      "zip": "Código Postal",
      "submit_button": "Recibir una cotización",
      "submit_button_when_calculating": "Calculando..."
    }
  },
  "collections": {
    "general": {
      "all_of_collection": "Todos",
      "no_matches": "Lo sentimos, no hay productos que coincidan con su búsqueda.",
      "link_title": "Navegue por nuestra colección {{ title }}",
      "grid_view": "Tabla",
      "list_view": "Lista",
      "items_with_count": {
        "one": "{{ count }} artículo",
        "other": "{{ count }} artículos"
      },
      "quickview": "Vista Rápida",
      "title": "Lista de Colecciones",
      "view_all": "Ver todos",
      "shop_the_collection": "Comprar La Colección",
      "clear": "Borrar",
      "refine_by": "Refinar por",
      "clear_all": "Borrar todo",
      "filter": "Filtrar",
      "showing": "Mostrando",
      "of": "de",
      "previous": "Anterior",
      "next": "Siguiente",
      "show_more": "Leer más",
      "loading": "Cargando",
      "no_more_product": "No hay más productos"
    },
    "sidebar": {
      "tags": "Etiquetas",
      "categories": "Categorías",
      "shopby": "Comprar por"
    },
    "sorting": {
      "title": "Ordenar por",
      "featured": "Destacados",
      "best_selling": "Más vendidos",
      "az": "Alfabéticamente, A-Z",
      "za": "Alfabéticamente, Z-A",
      "price_ascending": "Precio, menor a mayor",
      "price_descending": "Precio, mayor a menor",
      "date_descending": "Fecha, nuevo a antiguo",
      "date_ascending": "Fecha, antiguo a nuevo",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "Todos"
    },
    "onboarding": {
      "modal_title": "Esta página mostrará todos los productos de su tienda",
      "no_products_html": "Todavía no hay productos pero, una vez que comience a añadirlos, se mostrarán aquí sin importar si están en una colección.",
      "add_product": "Agregar producto"
    },
    "limiter": {
      "title": "Mostrar",
      "limit_16": "16",
      "limit_22": "22",
      "limit_44": "44",
      "limit_all": "Todos"
    },
    "onepage": {
      "seemore": "Ver más"
    }
  },
  "contact": {
    "form": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Número de teléfono",
      "message": "Mensaje",
      "send": "Enviar",
      "post_success": "Gracias por contactarnos. Le responderemos lo antes posible.",
      "title": "Dejar un",
      "title_after": "Mensaje",
      "comment": "Comentario",
      "submit": "Enviar"
    }
  },
  "customer": {
    "account": {
      "title": "Mi cuenta",
      "details": "Detalles de la cuenta",
      "view_addresses": "Ver direcciones",
      "return": "Volver a detalles de la cuenta"
    },
    "activate_account": {
      "title": "Activar cuenta",
      "subtext": "Cree su contraseña para activar su cuenta.",
      "password": "Contraseña",
      "password_confirm": "Confirmar contraseña",
      "submit": "Activar cuenta",
      "cancel": "Rechazar invitación"
    },
    "addresses": {
      "title": "Sus direcciones",
      "default": "Por defecto",
      "add_new": "Agregar una nueva dirección",
      "edit_address": "Editar dirección",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "company": "Compañía",
      "address1": "Dirección1",
      "address2": "Dirección2",
      "city": "Ciudad",
      "country": "País",
      "province": "Provincia",
      "zip": "Código postal",
      "phone": "Teléfono",
      "set_default": "Fijar como dirección por defecto",
      "add": "Agregar dirección",
      "update": "Actualizar dirección",
      "cancel": "Cancelar",
      "edit": "Editar",
      "delete": "Eliminar",
      "delete_message": "Estas seguro de borrar esta dirección?"
    },
    "login": {
      "title": "Ingresar",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "forgot_password": "¿Olvidó su contraseña?",
      "sign_in": "Registrarse",
      "cancel": "Volver a la tienda",
      "guest_title": "Continuar como invitado",
      "guest_continue": "Continuar",
      "heading": "Entrar o Crear Cuenta",
      "page_title": "Entrar",
      "log_in": "Entrar",
      "register": "Nuevos Clientes",
      "register_button": "Crear una Cuenta",
      "content": "Si tiene una cuenta con nosotros, por favor inicie sesión.",
      "register_content": "Al crear una cuenta en nuestra tienda, podrá avanzar más rápidamente en el proceso de compra, almacenar múltiples direcciones de envío, ver y rastrear sus pedidos en su cuenta y más."
    },
    "orders": {
      "title": "Historial de pedidos",
      "order_number": "Pedido",
      "date": "Fecha",
      "payment_status": "Estado del pago",
      "fulfillment_status": "Estado de finalización",
      "total": "Total",
      "none": "No ha realizado algún pedido aún."
    },
    "order": {
      "title": "Pedido {{ name }}",
      "date": "Realizado en {{ date }}",
      "cancelled": "Pedido cancelado en {{ date }}",
      "cancelled_reason": "Motivo: {{ reason }}",
      "billing_address": "Dirección de facturación",
      "payment_status": "Estado del pago",
      "shipping_address": "Dirección de envío",
      "fulfillment_status": "Estado de finalización",
      "discount": "Descuento",
      "shipping": "Envío",
      "tax": "Impuesto",
      "product": "Producto",
      "sku": "SKU",
      "price": "Precio",
      "quantity": "Cantidad",
      "total": "Total",
      "fulfilled_at": "Finalizado {{ date }}",
      "subtotal": "Subtotal"
    },
    "recover_password": {
      "title": "Restablecer su contraseña",
      "email": "Correo electrónico",
      "submit": "Enviar",
      "cancel": "Cancelar",
      "subtext": "Le enviaremos un correo electrónico para restablecer su contraseña.",
      "success": "Hemos enviado un correo electrónico con un enlace para actualizar su contraseña."
    },
    "reset_password": {
      "title": "Restablecer contraseña de cuenta",
      "subtext": "Ingrese una nueva contraseña para {{ email }}",
      "password": "Contraseña",
      "password_confirm": "Confirmar contraseña",
      "submit": "Restablecer contraseña"
    },
    "register": {
      "title": "Crear cuenta",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "email": "Correo electrónico",
      "password": "Contraseña",
      "submit": "Crear",
      "cancel": "Volver a la tienda",
      "page_title": "Registrarse",
      "title_form": "Informacion personal",
      "required": "* Campos requeridos",
      "message": "Por favor ingrese la siguiente información para crear su cuenta."
    },
    "logout": {
      "title": "Salir"
    }
  },
  "homepage": {
    "sections": {
      "frontpage_title": "Colección de portada",
      "featured_title": "Colecciones destacadas",
      "news_title": "Últimas noticias"
    },
    "onboarding": {
      "modal_title": "Casi allí...",
      "no_products_html": "No tiene productos en su colección de portada. Este indicador aparecerá hasta que <a href=\"\/admin\/collections?tutorial=Frontpage\">agregue un producto a esta colección<\/a>.",
      "add_product": "Añadir un producto",
      "product_title": "Ejemplo título de producto",
      "no_collections_html": "No tiene colecciones para mostrar aquí. <a href=\"\/admin\/custom_collections\">Agregue algunas colecciones<\/a> que acompañen a la Portada por defecto.",
      "add_collection": "Añadir una colección",
      "collection_title": "Ejemplo título de colección"
    }
  },
  "layout": {
    "navigation": {
      "menu": "Menú"
    },
    "drawers": {
      "browse": "Navegar",
      "close_menu": "Cerrar menú"
    },
    "cart": {
      "title": "Carrito",
      "items_count": {
        "one": "artículo",
        "other": "artículos"
      }
    },
    "customer": {
      "account": "Cuenta",
      "logged_in_as_html": "Conectado como {{ first_name }}",
      "log_out": "Cerrar sesión",
      "log_in": "Ingresar",
      "create_account": "Crear cuenta"
    },
    "footer": {
      "social_title": "Conectarse",
      "newsletter_title": "Boletín",
      "accepted_payments": "Pagos aceptados"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Producto anterior",
      "next_product_html": "Siguiente producto &rarr;",
      "from_text_html": "De {{ price }}",
      "sale_price": "Precio de oferta",
      "regular_price": "Precio habitual",
      "related_products": "También han comprado",
      "sale": "Venta",
      "show_all": "Mostrar todos",
      "show_more": "Ver más",
      "no_more_product": "No hay más artículos"
    },
    "product": {
      "sold_out": "Agotado",
      "on_sale": "En oferta",
      "on_sale_from_html": "<strong>En oferta<\/strong> desde {{ price }}",
      "unavailable": "No disponible",
      "compare_at": " Comparar en",
      "quantity": "Cantidad",
      "add_to_cart": "Agregar al carrito",
      "quickview": "Vista Rápida",
      "select_options": "Seleccione opciones",
      "tab_title_description": "Más información",
      "tab_title_review": "Comentarios",
      "share": "Compartir:",
      "availability": "Disponibilidad:",
      "sku": "Código del articulo:",
      "in_stock": "Disponible",
      "out_of_stock": "No hay disponible",
      "many_in_stock": "Muchos disponible",
      "product_type": "Tipo de articulo",
      "product_vendor": "Vendedor:",
      "count_down": "Ofertas de tiempo limitado, finalizan en:"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "¡Aquí está su tarjeta de regalo de {{ value }} para {{ shop }}!",
      "subtext": "¡Aquí está su tarjeta de regalo!",
      "disabled": "Inhabilitada",
      "expired": "Expiró en {{ expiry }}",
      "active": "Expira en {{ expiry }}",
      "redeem": "Use este código al terminar la comprar para canjear su tarjeta de regalo",
      "shop_link": "Empezar a comprar",
      "print": "Imprimir"
    }
  },
  "date_formats": {
    "month_day_year": "%d de %B, %Y"
  },
  "header": {
    "settings": {
      "login": "Entrar o Crear una cuenta",
      "register": "Registrate",
      "logout": "Salir",
      "my_account": "Mi Cuenta",
      "wishlist": "Mis Favoritos",
      "compare": "Compare",
      "currency": "Moneda",
      "newsletter_signup": "Unirse a nuestra comunidad",
      "language": "Lenguajes",
      "daily_deal": "Ofertas Diarias",
      "blog": "Blog",
      "links": "Enlaces",
      "shop": "Tienda"
    },
    "topbar": {
      "my_cart": "Mi Carrito",
      "search": "Buscar"
    }
  },
  "wish_list": {
    "general": {
      "wishlist": "Lista",
      "add_to_wishlist": "Añadir a tu lista",
      "browse_wishlist": "Buscar en tu lista",
      "product": "Producto",
      "price": "Precio",
      "remove": "ha sido removido de la lista",
      "quantity": "Cantidad",
      "options": "Opciones",
      "no_item": "No hay articulos en tu lista",
      "item_exist": "ya existe en tu lista",
      "item_added": "ha sido añadido a tu lista"
    }
  },
  "compare_list": {
    "general": {
      "compare": "Cuadro de comparación",
      "add_to_compare": "Añadir para comparación",
      "price": "Precio",
      "product": "Producto",
      "remove": "ha sido removido del cuadro de comparación",
      "quantity": "Cantidad",
      "options": "Opciones",
      "no_item": "No hay artículos en el cuadro de comparación",
      "item_exist": "existe en el cuadro de comparación",
      "item_added": "ha sido añadido al cuadro de comparación",
      "features": "Características",
      "actions": "Acciones"
    }
  }
}